<template>
    <el-dialog
        class="add"
        :visible.sync="refuseVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="600px"
        title="拒绝"
    >
        <el-form ref="form" :rules="rules" :model="form" label-width="100px">
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item label="拒绝原因" size="small" prop="refuse">
                        <el-input
                            type="textarea"
                            placeholder="请输入拒绝原因"
                            maxlength="1000"
                            size="small"
                            v-model="form.refuse"
                            :autosize="{ minRows: 4, maxRows: 6 }"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="refuseVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
export default {
    data() {
        return {
            form: {
                refuse: "",
            },
            rules: {
                refuse: [{ required: true, message: "请输入拒绝原因" }],
            },
        };
    },
    methods: {
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.$refs["form"].clearValidate();
            this.$refs["form"].resetFields();
            this.$emit("update:refuseVisible", false);
        },
        /**
         *  保存
         */
        save() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    // status: 50 已拒绝
                    oaApi
                        .workOrdersUpdateStatus(
                            { ...this.form, status: 50, id: this.tableItem.id },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                if (res.code == 200) {
                                    this.$message.success("操作成功");
                                    this.$parent.workOrdersList();
                                }
                                this.closeDialog();
                            }
                        });
                }
            });
        },
    },
    props: {
        refuseVisible: Boolean,
        tableItem: () => {},
    },
    watch: {
        refuseVisible: {
            handler(val) {},
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.add {
    .el-form-item__content {
        .el-select,
        .el-select--small,
        .el-input--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
}
</style>
